import React from "react";

import MediaCardSection from "./MediaCardSection";

export default function ProductsMediaCardSection(props) {
	const { productType, products } = props;

	if (!products?.items) return <>No Products for {productType}</>;

	const filteredProducts = products.items.filter((item) => {
		if (!item.fields?.productType) return;
		return item.fields.productType === productType;
	});

	return <MediaCardSection data={{ fields: { isContainer: "md", mediaCards: filteredProducts } }} />;
}
